import React from 'react';
import { useRecoilValue } from 'recoil';
import { Color } from '../enums/Color.enum';
import { Direction, useProductAssets } from '../hooks/useProductAssets';
import { ViewProduct } from '../models/ViewProduct.model';
import LazyImageLoader from '../product_detail/components/LazyImageLoader';
import { assetPathFnState } from '../recoil/atoms';

const byColor =
  (targetColor: Color | undefined) =>
  ({ color }: { color: Color } & any) =>
    color === targetColor;

export const ProductGhostSelector: React.FC<{ product: ViewProduct; color: Color | undefined; imageOverride?: string }> = ({
  product,
  color,
  imageOverride,
}) => {
  const assets = useProductAssets(product);
  const assetPathFn = useRecoilValue(assetPathFnState);
  const mannequinPhotos = assets.mannequinPhotos.filter((p) => p.direction === Direction.Front);

  const ghostMannequin = imageOverride
    ? { src: assetPathFn(imageOverride) }
    : mannequinPhotos.filter(byColor(color))[0] ??
      mannequinPhotos.filter(byColor(Color.Runway))[0] ??
      mannequinPhotos.filter(byColor(Color.Vamp))[0] ??
      mannequinPhotos[0] ??
      assets.mannequinPhotos[0];

  return ghostMannequin ? <LazyImageLoader alt={`Select ${product.title}`} width={60} height={76} src={ghostMannequin.src} /> : <></>;
};

export default ProductGhostSelector;
